var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTn = function SvgTn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-85.333 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "matrix(.9 0 0 .9 80 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e70013",
    d: "M-128 0h768v512h-768z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.808 255.773c0 71.316-57.813 129.13-129.13 129.13-71.316 0-129.13-57.815-129.13-129.13s57.815-129.13 129.13-129.13c71.318 0 129.13 57.814 129.13 129.13z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.68 341.41c-47.27 0-85.635-38.364-85.635-85.635s38.364-85.636 85.635-85.636c11.818 0 25.27 2.718 34.407 9.43-62.63 2.356-78.472 55.476-78.472 76.884s10.128 69.154 78.47 76.205c-7.776 5.012-22.587 8.75-34.405 8.75z",
    fill: "#e70013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e70013",
    d: "M332.11 291.785l-38.89-14.18-25.72 32.417 1.477-41.356-38.787-14.45 39.798-11.373 1.744-41.356 23.12 34.338 39.87-11.116-25.504 32.593z"
  }))));
};
export default SvgTn;